exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".section[data-v-abedb8c8]{padding-left:8px;padding-right:8px}.map-image[data-v-abedb8c8]{margin:0 40px 20px}.map-image img[data-v-abedb8c8]{width:100%}.button.is-default[data-v-abedb8c8]{padding:18px 24px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-abedb8c8","scoped":true,"hasInlineConfig":false}!./node_modules/sass-loader/dist/cjs.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/Access.vue
// module id = WYYd
// module chunks = 1